// Cena 8 — Filas (áudio ~20s)
// O cursor clica no botão REAL "Adicionar fila", o modal grande centralizado
// abre com o nome "Vendas" digitando sozinho, a cor verde é escolhida na
// paleta, salva — e os três setores aparecem prontos em chips coloridos.
const MAIN = "[data-tour='main-content']";
const BTN_ADD = "[data-tour='btn-add-queue']";
const COLOR_0 = "[data-demo='color-0']";
const SAVE = "[data-demo='save']";

export default async function queues(ctx) {
	// "As Filas organizam o atendimento por setores..."
	await ctx.waitFor(BTN_ADD);
	ctx.spotlight(BTN_ADD);
	await ctx.wait(1100);

	// cursor vai ao botão real de nova fila e clica
	await ctx.cursorTo(BTN_ADD, { duration: 1000 });
	await ctx.wait(350);
	await ctx.click(BTN_ADD);

	// "...como Vendas, Suporte e Financeiro." — modal central abre
	// (o queueModal centraliza e ativa o blur de fundo sozinho)
	ctx.spotlight(null);
	const modal = ctx.mount("queueModal", MAIN, {
		name: "Vendas",
		nameDone: false,
		picked: -1,
	});
	await ctx.wait(2600);

	// "Cada fila tem nome e cor..." — cursor desce até a paleta e escolhe o verde
	await ctx.waitFor(COLOR_0);
	await ctx.cursorTo(COLOR_0, { duration: 800 });
	await ctx.wait(300);
	await ctx.click(COLOR_0);
	ctx.update(modal, { picked: 0, nameDone: true });
	await ctx.wait(1200);

	// "...e você escolhe pra quais filas cada WhatsApp direciona os clientes."
	await ctx.waitFor(SAVE);
	await ctx.cursorTo(SAVE, { duration: 700 });
	await ctx.wait(250);
	await ctx.click(SAVE);
	ctx.update(modal, { saving: true });
	await ctx.wait(900);
	ctx.unmount(modal);
	await ctx.wait(400);

	// os três setores prontos, lado a lado
	ctx.mount("chipRow", MAIN, {
		items: [
			{ name: "Vendas", color: "#10B981" },
			{ name: "Suporte", color: "#3B82F6" },
			{ name: "Financeiro", color: "#8B5CF6" },
		],
		style: { position: "absolute", left: 24, top: 130 },
	});
	await ctx.wait(400);

	// cursor passeia sobre os chips (pontos genéricos do conteúdo)
	await ctx.cursorTo({ sel: MAIN, ax: 0.08, ay: 0.18 }, { duration: 750 });
	await ctx.wait(400);
	await ctx.cursorTo({ sel: MAIN, ax: 0.3, ay: 0.18 }, { duration: 900 });

	// "Assim, cada pessoa cai direto com a equipe certa!"
	const toast = ctx.mount("toast", MAIN, {
		icon: "🗂️",
		text: "Setores organizados!",
	});
	await ctx.wait(2300);
	ctx.unmount(toast);
	await ctx.wait(300);

	ctx.spotlight(null);
	await ctx.cursorTo({ sel: MAIN, ax: 0.45, ay: 0.45 }, { duration: 850 });
}
